<template>
<div class='videoPage'>
  <!-- 轮播图 -->
    <Carousel v-model="value"
     loop
     :autoplay="setting.autoplay"
     :autoplay-speed="setting.autoplaySpeed"
     :dots="setting.dots"
     :radius-dot="setting.radiusDot"
     :trigger="setting.trigger"
     :arrow="setting.arrow">
        <CarouselItem v-for="ites in rotasArr" :key="ites.id">
            <div class="demo-carousel">
              <img :src="ites.videoImg" @click="goVideo(ites.id)" alt="">
            </div>
        </CarouselItem>
    </Carousel>
    <Row class="bottomBox" style="padding-bottom:0">
    <Col span="22" class="guide" style="padding:0 .5vw">
          <div>
            <span class="guideText">精选视频</span>
          </div> 
    </Col>
    </Row>
    <!-- 视频展示 -->
    <Row class="topBox">
      <Col span="6" class="videoBox" v-if="myClasslist.length>0">
        <Col span="24" class="items" style="width:100%;height:100%;margin:0">
          <span class="sign" v-if="myClasslist[0].videoRates == 2">VIP</span>
          <img :src="myClasslist[0].videoImg" alt="" style="height:100%">
          <p class="videoTitle" style="font-size:1.2vw"><span>{{myClasslist[0].videoName}}</span></p>

          <div class="list-cover">
            <Icon type="md-star-outline" class="collect_icon" @click="collect(myClasslist[0].id)" v-if="myClasslist[0].collect == 2"/>
            <Icon type="md-star" class="collect_icon" @click="uncollect(myClasslist[0].id)" style="color:#FFCC00" v-if="myClasslist[0].collect == 1"/>
            <img :src="myClasslist[0].videoImg" alt="" style="height:100%" @click="goVideo(myClasslist[0].id)">
            <div style="padding:0 .4vw"><p class="videoTitle" style="color: #fff;font-size: 1.4vw;" @click="goVideo(myClasslist[0].id)">{{myClasslist[0].videoTitle}}</p></div>
          </div>
        </Col>
      </Col>
      <Col span="18" class="videoBox" style="padding-left:2vw">
        <Col span="4" class="items" @click.native="goTest">
          <img src="../assets/images/exam.jpg" alt="">
          <p class="testTitle">考试</p>
        </Col>
        <Col span="4" v-for="(item,index) in myClasslist" :key="index" class="items" v-show="index>0">
          <span class="sign" v-if="item.videoRates == 2">VIP</span>
          <!-- <video src="https://www.runoob.com/try/demo_source/mov_bbb.mp4"></video> -->
          <img :src="item.videoImg" alt="" @click="goVideo(item.id,item.videoRates)">
          <p class="videoTitle" @click="goVideo(item.id,item.videoRates)"><span>{{item.videoName}}</span></p>
          <div class="list-cover">
            <Icon type="md-star-outline" class="collect_icon" @click="collect(item.id)" v-if="item.collect == 2"/>
            <Icon type="md-star" class="collect_icon" @click="uncollect(item.id)" style="color:#FFCC00" v-if="item.collect == 1"/>
            <img v-if='item.videoImg' :src="item.videoImg" alt="" @click="goVideo(item.id)">
            <div style="padding:0 .4vw"><p class="videoTitle" style="color: #fff;font-size: .85vw;" @click="goVideo(item.id)">{{item.videoTitle}}</p></div>
          </div>
        </Col>
      </Col>
    </Row>

    <Row class="bottomBox">
        <Col span="22" class="guide">
            <div v-for="(val,valIndex) in videoTypeList" :key="valIndex" v-show="valIndex>0">
              <span class="guideText" @click="videoTypeChange(val,valIndex)" :style="{color:(valIndex == vindex? 'rgb(45, 183, 245)':'')}">{{val.name}}</span>
              <Divider type="vertical" v-if="videoTypeList.length != valIndex+1"/>
            </div> 
        </Col>
        <Col span="22" class="videoBox">
          <Col span="5" v-for="(item,index) in videoCollectionList" :key="index" class="items" style="width:12vw">
              <div>
                <span class="sign" v-if="item.videoRates == 2">VIP</span>
                  <!-- <video src="https://www.runoob.com/try/demo_source/mov_bbb.mp4"></video> -->
                  <img v-if='item.videoImg' :src="item.videoImg" alt="">
                  <div style="padding:0 .4vw"><p class="videoTitle">{{item.videoTitle}}</p></div>
              </div>
              <div class="list-cover">
                <Icon type="md-star-outline" class="collect_icon" @click="collect(item.id)" v-if="item.collect == 2"/>
                <Icon type="md-star" class="collect_icon" @click="uncollect(item.id)" style="color:#FFCC00" v-if="item.collect == 1"/>
                <img v-if='item.videoImg' :src="item.videoImg" alt="" @click="goVideo(item.id,item.videoRates)">
                <div style="padding:0 .4vw"><p class="videoTitle" style="color: #000;font-size: .85vw;" @click="goVideo(item.id,item.videoRates)">{{item.videoTitle}}</p></div>
              </div>
          </Col>
        </Col>
    </Row>

    <!-- <Row class="bottomBox">
        <Col span="22" class="guide">
            <div>
            <span class="guideText">考试培训</span>
          </div> 
        </Col>
        <Col span="22" class="videoBox">
          <Col span="5" v-for="(item,index) in videoCollectionList" :key="index" class="items" style="width:12vw">
              <div>
                <span class="sign" v-if="item.videoRates == 2">VIP</span>
                  <img v-if='item.videoImg' :src="item.videoImg" alt="">
                  <div style="padding:0 .4vw"><p class="videoTitle">{{item.videoTitle}}</p></div>
              </div>
              <div class="list-cover">
                <Icon type="md-star-outline" class="collect_icon" @click="collect(item.id)" v-if="item.collect == 2"/>
                <Icon type="md-star" class="collect_icon" @click="uncollect(item.id)" style="color:#FFCC00" v-if="item.collect == 1"/>
                <img v-if='item.videoImg' :src="item.videoImg" alt="" @click="goVideo(item.id,item.videoRates)">
                <div style="padding:0 .4vw"><p class="videoTitle" style="color: #000;font-size: .85vw;" @click="goVideo(item.id,item.videoRates)">{{item.videoTitle}}</p></div>
              </div>
          </Col>
        </Col>
    </Row> -->
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
  value: 0,
  setting: {
      autoplay: true,
      autoplaySpeed: 2000,
      dots: 'inside',
      radiusDot: false,
      trigger: 'hover',
      arrow: 'hover'
  },
  isvip:false,
  rotasArr:[],//轮播图
  myClasslist:[],//我的课程数组
  videoTypeList:[],//视频类型数组
  videoCollectionList:[],//切換视频类型获取视频集
  vindex:1,//选中视频集
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
  var isvip= JSON.parse(sessionStorage.getItem("userInfo")).videoVipFlag;
  if(isvip==2){
    this.isvip=true
  }
  this.getmyClasslist()
  this.getvideoTypelist()
  this.getRotasArr()
},
//生命周期 - 挂载完成（可以访问DOM元素）
methods: {
  getmyClasslist(){//获取我的课程
    this.$axios
        .get("/safe-train/videoCollection/getAppList?size=8&chioiceness=2")
        .then((res) => {
          if (res.code == 1) {
            this.myClasslist = res.data;
          } else {
            this.$Message.error(res.msg);
          }
        });
  },
 getvideoTypelist(){//获取视频类型
    this.$axios
        .get("/safe-train/videoType/getVideoTypeList")
        .then((res) => {
          if (res.code == 1) {
            this.videoTypeList = res.data;
            if(this.videoTypeList.length>0){
              this.videoTypeChange(this.videoTypeList[1],1)
            }
          } else {
            this.$Message.error(res.msg);
          }
        });
 },
 videoTypeChange(val,index){//视频类型切换并获取视频集
   this.vindex = index
   this.$axios
        .get("/safe-train/videoCollection/getAppList?videoTypeId="+val.id)
        .then((res) => {
          if (res.code == 1) {
            this.videoCollectionList = res.data;
          } else {
            this.$Message.error(res.msg);
          }
        });
 },
  getRotasArr(){//获取轮播图
   this.$axios
        .get("/safe-train/videoCollection/getCarousel?carousel=1&limit=5")
        .then((res) => {
          if (res.code == 1) {
            this.rotasArr = res.data;
          } else {
            this.$Message.error(res.msg);
          }
        });
 },
 //跳转视频页面
 goVideo(id,videoRates){
   console.log(id,'id')
   if(this.isvip==false&&videoRates==1){
     this.$Message.warning('请开通会员后观看')
     return false
   }
   this.$router.push({name:'VideoPage',query:{id:id}})
 },
 //收藏
 collect(id){
      this.$axios
        .get("/safe-train/videoCollection/collect?id="+id)
        .then((res) => {
          if (res.code == 1) {
            this.$Message.success('收藏成功')
            this.getmyClasslist()
            // for(var i in this.myClasslist){
            //   if(id==this.myClasslist[i].id){
            //     this.myClasslist[i].collect=1
            //   }
            // }
            // for(var i in this.videoTypeList){
            //   if(id==this.videoTypeList[i].id){
            //     this.videoTypeList[i].collect=1
            //   }
            // }
            
            this.getvideoTypelist()
          } else {
            this.$Message.error(res.msg);
          }
    });
 },
 //取消收藏
  uncollect(id){
      this.$axios
        .get("/safe-train/videoCollection/collect?id="+id)
        .then((res) => {
          if (res.code == 1) {
            this.$Message.success('取消收藏成功')
            this.getmyClasslist()
            // for(var i in this.myClasslist){
            //   if(id==this.myClasslist[i].id){
            //     console.log(this.myClasslist[i].collect)
            //     this.myClasslist[i].collect=2

            //   }
            // }
            // for(var i in this.videoTypeList){
            //   if(id==this.videoTypeList[i].id){
            //     this.videoTypeList[i].collect=2
            //   }
            // }
            this.getvideoTypelist()
          } else {
            this.$Message.error(res.msg);
          }
    });
 },
 goTest(){
   this.$router.push({name:'Test'})
 }
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
.videoPage{
  height: 92vh!important;
  overflow: auto;
}
.demo-carousel{
  img{
    width: 100%;
    height: 45vh;
  }
}
.topBox{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: .5vw 4vw;
  height: 15vw;

  video{
    width: 100%;
    border-radius: 5px;
  }
  .videoBox {
    height: 100%;
    .items{
      width: 18.5%;
      height: 7vw;
      img{
        height: 100%;
      }
      .videoTitle{
        padding: 0 1vw;
        bottom: .4vw;
        span{
          overflow:hidden;            //超出的文本隐藏 
          text-overflow:ellipsis;     //溢出用省略号显示
          white-space:nowrap;         //溢出不换行,只能显示一行
        }
        
      }
      .testTitle{
        width: 100%;
        position: absolute;
        bottom: 0;
        color: #fff;
        font-size: .8vw;
        padding: 0 1vw;
        bottom: .4vw;
        font-size:1.2vw;
      }
      .testTitle:hover{
        color: #fff;
        font-size: 2vw;
        cursor: pointer;
        font-weight: bold;
      }
    }
  }
}
.bottomBox{  
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: .5vw 0;

  video{
    width: 100%;
    border-radius: 5px; 
  }
  .videoBox {
    .items{
      height: 12.2vw;
      .videoTitle{
        position: relative;
        background: transparent;
        color: #333;
        overflow:hidden; 
        // text-overflow:ellipsis;
        display:-webkit-box; 
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2;
      }
    }
  }
}
  .videoBox{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
      img{
        width: 100%;
        height: 9vw;
        border-radius: 5px;

      }
      video{
        width: 100%;
      }

      .items{
        position: relative;
        margin: .4vw;
        cursor: pointer;
        
        .videoTitle{
          width: 100%;
          position: absolute;
          bottom: 0;
          color: #fff;
          font-size: .8vw;
        }
        .sign{
          position: absolute;
          top: .4vw;
          right: 0;
          font-size: .6vw;
          padding: .1vw .2vw;
          background: #FFBB00;
          text-align: center;
          color: #330000;
          border-top-left-radius: .2vw;
          border-bottom-left-radius: .2vw;
        }
      }

      .list-cover{
        width: 100%;
        height: 100%;
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: #f5f5f5;
        box-shadow: .395vw .595vw 2vw #999;
        border-radius: 2px;
        overflow: hidden;
        cursor: pointer;
        

        .collect_icon{
          position: absolute;
          font-size: 2vw;
          color: #fff;
          right: 0;
        }

        img{
          width: 100%;
          padding: 0;
        }

        .videoTitle{
            overflow:hidden; 
            text-overflow:ellipsis;
            display:-webkit-box; 
            -webkit-box-orient:vertical;
            -webkit-line-clamp:2;
        }

      }
    .items:hover .list-cover{
          display: block;
      }
  }
  .guide{
    display: flex;
    align-items: center;
    padding: 0 .5vw .4vw;
    font-size: 1.2vw;
    color: #000;
    // background: #fff;
    // border-bottom: 1px solid #f5f5f5;
    font-weight: bold;
    span{
      cursor: pointer;
    }
    span:hover{
      color: rgb(45, 183, 245);
    }
  }
</style>